var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRooftopTent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102 90h-9v-6h6V63H87l-2.123-.877L73.757 51H21v-6h54l2.123.877L88.243 57H102l3 3v27l-3 3Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81H12V54h15v6h-9v15h9v6ZM78 48h-6V22.983L27 46.805V48h-6v-3l1.598-2.653 51-27L78 18v30Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.66 27.323 37.658 45.32l2.683 5.367L76.343 32.69l-2.683-5.367ZM79.5 97.5C73.71 97.5 69 92.79 69 87s4.71-10.5 10.5-10.5c2.805 0 5.442 1.093 7.425 3.075A10.433 10.433 0 0 1 90 87c0 5.79-4.71 10.5-10.5 10.5Zm0-15c-2.48 0-4.5 2.017-4.5 4.5s2.02 4.5 4.5 4.5S84 89.483 84 87a4.47 4.47 0 0 0-1.317-3.183A4.47 4.47 0 0 0 79.5 82.5ZM43.5 97.5C37.71 97.5 33 92.79 33 87s4.71-10.5 10.5-10.5c2.805 0 5.443 1.093 7.425 3.075A10.433 10.433 0 0 1 54 87c0 5.79-4.71 10.5-10.5 10.5Zm0-15c-2.48 0-4.5 2.017-4.5 4.5s2.02 4.5 4.5 4.5S48 89.483 48 87a4.47 4.47 0 0 0-1.318-3.183A4.47 4.47 0 0 0 43.5 82.5Z",
    fill: "#222",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81h-9l-3-3v-6H36v3h-6v-6l3-3h24l3 3v6h3v-6l3-3h24l3 3v6h-6v-3H69v6l-3 3ZM30 90h-6l-3-3V51h6v33h3v6ZM66 63h-9V46.5h6V57h3v6Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooftopTent);
export default __webpack_public_path__ + "static/media/rooftop-tent.f62ce8e6.svg";
export { ForwardRef as ReactComponent };